'use client';

import React from 'react';
import { Check } from 'lucide-react';

type Step = { id: number; label: string; desc: string };

export default function StepIndicator({
  steps,
  currentStep,
  onStepClick,
}: {
  steps: Step[];
  currentStep: number;
  onStepClick: (step: number) => void;
}) {
  return (
    <div className="bg-card border border-border rounded-2xl p-5">
      <div className="flex items-center gap-0">
        {steps.map((step, i) => (
          <React.Fragment key={`step-indicator-${step.id}`}>
            <button
              className={`flex items-center gap-3 flex-1 group transition-all ${
                step.id < currentStep ? 'cursor-pointer' : 'cursor-default'
              }`}
              onClick={() => onStepClick(step.id)}
              disabled={step.id >= currentStep}
            >
              {/* Circle */}
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-sm transition-all duration-200 ${
                  step.id < currentStep
                    ? 'step-completed'
                    : step.id === currentStep
                    ? 'step-active ring-4 ring-primary/20' :'step-pending'
                }`}
              >
                {step.id < currentStep ? <Check size={15} /> : step.id}
              </div>
              {/* Labels */}
              <div className="hidden sm:block text-left">
                <div
                  className={`text-xs font-bold leading-tight ${
                    step.id === currentStep ? 'text-primary' : step.id < currentStep ? 'text-success' : 'text-muted-foreground'
                  }`}
                >
                  {step.label}
                </div>
                <div className="text-xs text-muted-foreground">{step.desc}</div>
              </div>
            </button>

            {/* Connector */}
            {i < steps.length - 1 && (
              <div className="flex-1 h-0.5 mx-2 rounded-full overflow-hidden bg-border max-w-[40px]">
                <div
                  className="h-full bg-primary transition-all duration-500"
                  style={{ width: step.id < currentStep ? '100%' : '0%' }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}